export interface ContactPayload {
  name: string
  email: string
  phone: string
  message: string
  source: 'projekt' | 'interior-ai-pro'
}

/**
 * Set this to your form backend (e.g. Formspree, Make, or your own API)
 * to receive real submissions. While empty, submissions are simulated so
 * the full flow (sending → success) can be reviewed.
 */
export const CONTACT_ENDPOINT = ''

export async function submitContact(payload: ContactPayload): Promise<void> {
  if (!CONTACT_ENDPOINT) {
    await new Promise((resolve) => setTimeout(resolve, 1200))
    return
  }
  const response = await fetch(CONTACT_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(payload),
  })
  if (!response.ok) {
    throw new Error(`Contact submission failed (${response.status})`)
  }
}
